export default __webpack_public_path__ + "static/media/solution_50.d2959ed7.svg";